import React from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import LogoBenefits from '../../../assets/img/logoNovaBlack.png';

const Privacy = () => (
  <PageWrapper
    title="Termos de Uso e Política de Privacidade"
    description="Termos de uso e política de privacidade do uGet Benefícios."
    className="bg-light min-vh-100 py-4 py-md-5">
    <Page container="lg">
      <Card className="shadow-sm border-0">
        <CardBody className="p-4 p-md-5" style={{ fontSize: '1.08rem', lineHeight: 1.65 }}>
          <header className="mb-4">
            <div className="text-center mb-4">
              <img src={LogoBenefits} alt="uGet Benefícios" width={250} className="img-fluid" />
            </div>
            <p className="text-primary fw-bold text-uppercase mb-2">uGet Benefícios</p>
            <h1 className="display-6 mb-2">Termos de Uso e Política de Privacidade</h1>
            <p className="text-muted mb-0">Versão 1.0 | outubro de 2026</p>
          </header>

          <h2 className="h4 mt-4">1. Sobre o uGet Benefícios</h2>
          <p>
            O <strong>uGet Benefícios</strong> é uma plataforma tecnológica desenvolvida e operada
            pela <strong>UGET PDX TECNOLOGIA E SOLUÇÕES LTDA.</strong>, inscrita no CNPJ nº{' '}
            <strong>33.399.652/0001-08</strong>, destinada à gestão, distribuição, utilização e
            acompanhamento de créditos de benefícios.
          </p>
          <p>
            A plataforma pode ser utilizada por empresas privadas, organizações sociais, entidades
            do terceiro setor, órgãos públicos e demais instituições que concedam ou administrem
            benefícios a pessoas físicas.
          </p>
          <p>
            Este documento estabelece as condições gerais de utilização da plataforma e as regras
            de privacidade aplicáveis a todos os beneficiários, independentemente da instituição,
            empresa, organização ou órgão público ao qual estejam vinculados.
          </p>
          <p>
            Os benefícios poderão ser destinados à aquisição de alimentos, refeições, gás,
            combustíveis, medicamentos, livros, materiais escolares e outros produtos ou serviços
            autorizados pela instituição responsável.
          </p>

          <h2 className="h4 mt-4">2. Cadastro e dados pessoais</h2>
          <p>
            Para permitir a utilização dos benefícios, poderão ser coletados e tratados os
            seguintes dados:
          </p>
          <ul>
            <li><strong>Dados cadastrais:</strong> nome, CPF, data de nascimento, endereço, telefone e e-mail.</li>
            <li><strong>Dados dos benefícios:</strong> valores concedidos, modalidades, créditos e saldos disponíveis.</li>
            <li><strong>Dados das transações:</strong> estabelecimento, data, valor da compra e categoria ou tipo de produto adquirido.</li>
            <li><strong>Dados de segurança:</strong> informações necessárias à identificação, autenticação, prevenção de fraudes e proteção das operações.</li>
          </ul>
          <p>
            O cadastro poderá ser realizado diretamente pelo beneficiário, por meio do aplicativo,
            ou pelas empresas, organizações e instituições responsáveis pela administração dos benefícios.
          </p>
          <p>
            Os dados serão utilizados para identificação, disponibilização e utilização dos créditos,
            processamento das transações, prestação de contas, segurança e cumprimento das obrigações
            legais aplicáveis.
          </p>

          <h2 className="h4 mt-4">3. Compartilhamento e acesso às informações</h2>
          <p>
            Os dados pessoais poderão ser acessados ou compartilhados, de acordo com a finalidade,
            a necessidade e as atribuições de cada participante, com:
          </p>
          <ol type="a">
            <li><strong>UGET PDX:</strong> responsável pela operação tecnológica, manutenção, suporte e segurança da plataforma.</li>
            <li><strong>Instituições Responsáveis pelo Benefício:</strong> empresas, organizações, entidades públicas ou privadas que concedam, financiem ou administrem os benefícios, podendo consultar dados cadastrais, créditos, saldos e histórico individual de transações para gestão, controle e fiscalização.</li>
            <li><strong>Estabelecimentos Credenciados:</strong> terão acesso limitado às informações necessárias para autorizar, realizar e comprovar as transações.</li>
            <li><strong>Órgãos de Fiscalização e Controle:</strong> informações poderão ser disponibilizadas a auditorias, Tribunais de Contas e demais autoridades competentes, quando necessário e permitido pela legislação.</li>
          </ol>
          <p>O acesso aos dados será limitado às informações necessárias ao exercício das atribuições de cada participante.</p>
          <p>
            A utilização da plataforma por diferentes instituições não autoriza o compartilhamento de informações entre elas. Cada instituição terá acesso somente aos dados vinculados aos programas sob sua responsabilidade, ressalvadas as hipóteses legalmente autorizadas.
          </p>

          <h2 className="h4 mt-4">4. Utilização dos benefícios e do cartão</h2>
          <p>
            Os benefícios poderão ser utilizados por meio de cartão com tecnologia NFC, mediante aproximação e confirmação por senha pessoal (PIN), nos estabelecimentos credenciados.
          </p>
          <p>O beneficiário poderá utilizar o aplicativo para:</p>
          <ul>
            <li>Consultar créditos e saldos disponíveis;</li>
            <li>Acompanhar o histórico de transações;</li>
            <li>Bloquear o cartão em caso de perda, roubo ou furto;</li>
            <li>Desbloquear o cartão, conforme as funcionalidades autorizadas.</li>
          </ul>
          <p>Os créditos deverão ser utilizados exclusivamente nas categorias e condições definidas pela Instituição Responsável pelo Benefício.</p>
          <p>A UGET disponibiliza a tecnologia para operacionalização dos benefícios, cabendo às instituições responsáveis estabelecer os critérios de concessão, valores, elegibilidade e regras específicas de utilização.</p>

          <h2 className="h4 mt-4">5. Segurança e proteção de dados</h2>
          <p>
            A UGET adota medidas técnicas e administrativas destinadas a proteger os dados pessoais contra acessos não autorizados, perda, divulgação ou utilização indevida.
          </p>
          <p>As informações serão utilizadas exclusivamente para finalidades legítimas relacionadas à operação da plataforma e às obrigações legais aplicáveis.</p>
          <p>Os dados pessoais dos beneficiários não serão comercializados nem utilizados para publicidade de terceiros sem fundamento legal adequado.</p>
          <p>
            Os dados poderão ser armazenados pelo período necessário à execução dos benefícios,
            prestação de contas, auditorias e cumprimento das obrigações legais pertinentes.
          </p>

          <h2 className="h4 mt-4">6. Direitos e responsabilidades do beneficiário</h2>
          <p>
            O beneficiário deverá manter seus dados atualizados, proteger sua senha pessoal e utilizar os créditos exclusivamente nas condições autorizadas.
          </p>
          <p>Em caso de perda, roubo, furto ou suspeita de utilização indevida do cartão, deverá realizar o bloqueio pelo aplicativo.</p>
          <p>O beneficiário poderá consultar seus dados pessoais, solicitar correções e exercer os demais direitos previstos na Lei Geral de Proteção de Dados Pessoais (LGPD), observadas as condições legais aplicáveis.</p>
          <p>Para dúvidas sobre a concessão, valores ou regras dos benefícios, deverá procurar a instituição responsável pelo respectivo programa.</p>
          <p>
            Para questões relacionadas à privacidade e proteção de dados pessoais, poderá entrar em contato pelo e-mail:{' '}
            <a href="mailto:contato@uget.com.br">contato@uget.com.br</a>.
          </p>

          <h2 className="h4 mt-4">7. Aceitação dos Termos</h2>
          <p>Ao aceitar este documento, o beneficiário declara que leu e compreendeu as condições gerais de utilização do <strong>uGet Benefícios</strong> e tomou conhecimento das informações sobre o tratamento e compartilhamento de seus dados pessoais.</p>
          <p>Este Termo é aplicável a todos os beneficiários da plataforma, independentemente da empresa, organização, instituição privada ou órgão público responsável pela concessão ou administração dos benefícios.</p>
          <p>As condições específicas de cada programa serão estabelecidas pela respectiva Instituição Responsável pelo Benefício, respeitada a legislação aplicável.</p>
          <p>O tratamento dos dados pessoais observará as bases legais previstas na LGPD, não dependendo exclusivamente deste aceite.</p>
          <div className="form-check mt-4">
            <input className="form-check-input" id="privacy-acceptance" type="checkbox" />
            <label className="form-check-label" htmlFor="privacy-acceptance">
              Li e aceito os Termos de Uso e estou ciente da Política de Privacidade do uGet Benefícios.
            </label>
          </div>
        </CardBody>
      </Card>
    </Page>
  </PageWrapper>
);

export default Privacy;
